import React from 'react';
import MessageStatus from './MessageStatus.jsx'; // Import the new component

/**
 * Renders a single chat message.
 * @param {object} props - Component props.
 * @param {object} props.message - The message object, e.g., { id, text, senderId, timestamp, status }.
 * @param {string} props.currentUserId - The ID of the currently logged-in user.
 */
const ChatMessage = ({ message, currentUserId }) => {
  const isMyMessage = message.senderId === currentUserId;

  // Helper function to format the Firebase Timestamp
  const formatTimestamp = (timestamp) => {
    // Check if the timestamp is a valid Firebase Timestamp object
    if (timestamp && typeof timestamp.toDate === 'function') {
      // Convert to a readable time string, e.g., "10:30 AM"
      return timestamp.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    // Fallback for temporary messages or other date formats
    if (timestamp) {
      return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    // Fallback for when timestamp is not yet available
    return '...';
  };

  return (
    <div className={`flex items-end w-full ${isMyMessage ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`flex flex-col max-w-xs md:max-w-md mx-2 ${isMyMessage ? 'items-end animate-slide-in-right' : 'items-start animate-slide-in-left'}`}
      >
        <div
          className={`px-4 py-2 rounded-3xl max-w-[85%] shadow-sm ${isMyMessage
            ? 'bg-gradient-to-r from-matrimony-500 to-matrimony-600 text-white rounded-br-md' // Matrimony Theme
            : 'bg-stone-200 text-stone-900 rounded-bl-md' // Matrimony Light Gray
            }`}
        >
          <p className="text-[15px] break-words">{message.text}</p>
          <div
            className={`flex items-center justify-end mt-1 space-x-1 ${isMyMessage ? 'text-matrimony-100' : 'text-stone-500' // Subtle timestamp
              }`}
          >
            <span className="text-xs mr-1">{formatTimestamp(message.timestamp)}</span>
            {/* Only display the status icon for messages sent by the current user */}
            {isMyMessage && <MessageStatus status={message.status} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;